import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import BaseDialog from 'core/components/base-dialog/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { NotificationCard } from 'core/components/notification-card';

import useStyles from './cancel-task-modal.styles';

const CancelModal = ({ open, onClose, taskName, onCancel }) => {
  const classes = useStyles();

  return (
    <BaseDialog open={open} onClose={onClose} classes={{ paper: classes.container }}>
      <Label type="greenBig" className={classes.modalHeader}>
        Cancel the "{taskName}" task?
      </Label>
      <Label type="darkGreenSmall" className={classes.modalContent}>
        This will remove the task and it will no longer show for members or Staff users. Any uploaded files for this
        task will still be accessible in the internal documents to anyone with access.
      </Label>
      <NotificationCard iconByHeader iconSize="icon16" noShadow type={'light'}>
        Proceeding with the cancel will NOT trigger a communication to the member. Manual outreach is required if
        additional member action is needed
      </NotificationCard>
      <Grid className={classes.btnContainer}>
        <Button variant="contained" color="secondary" className={classes.noBtn} onClick={onClose}>
          No, keep
        </Button>
        <Button variant="contained" color="primary" className={classes.yesBtn} onClick={onCancel}>
          Yes, cancel task
        </Button>
      </Grid>
    </BaseDialog>
  );
};

CancelModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  taskName: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default CancelModal;
